import React from 'react'

export const ProveedoresPage = () => {
  return (
    <div>ProveedoresPage</div>
  )
}
